import { useState } from "react";
import { None, Option } from "space-monad";
import { WrapWithStepperContext } from "../../../../../components/stepper/context";
import { HorizontalLinearStepper } from "../../../../../components/stepper/horizontal";
import { StepInfo } from "../../../../../components/stepper/models";
import Confirm from "./confirm";
import Form from "./form";
import ResultPage from "./result";

const steps: Array<StepInfo & { content: typeof Form | typeof Confirm }> = [
  {
    title: "Select",
    content: Form,
  },
  {
    title: "Confirmation",
    content: Confirm,
    nextButtonText: "Confirm",
  },
];

interface IClaimRewardsModalProps {
  onClose: () => void;
}

const ClaimRewardsModal: React.FunctionComponent<IClaimRewardsModalProps> = ({
  onClose,
}) => {
  // State for stake
  const [stake, setStake] = useState<boolean>(true);

  // State for error
  const [error, setError] = useState<Option<Error>>(None);

  return (
    <WrapWithStepperContext>
      <HorizontalLinearStepper
        onFinish={onClose}
        finishText="Close"
        finalPage={<ResultPage error={error} />}
        steps={steps}
        stepsProps={{ setStake, stake, setError }}
      />
    </WrapWithStepperContext>
  );
};

export default ClaimRewardsModal;
